'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { cloneElement, type ReactElement } from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';
import { Button } from '@shared/ui-components/button/button';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { Menu } from '@shared/ui-components/svgs';
import { Drawer } from '../../../drawer/drawer';
import styles from './modal-trigger.module.scss';
export const ModalTrigger = t0 => {
  const $ = _c(22);
  const {
    children,
    isSecondaryTheme
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const state = useOverlayTriggerState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: "dialog"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    overlayProps,
    triggerProps
  } = useOverlayTrigger(t2, state);
  let restTriggerProps;
  if ($[2] !== triggerProps) {
    const {
      onPress,
      ...t3
    } = triggerProps;
    restTriggerProps = t3;
    $[2] = triggerProps;
    $[3] = restTriggerProps;
  } else {
    restTriggerProps = $[3];
  }
  let t3;
  if ($[4] !== isSecondaryTheme) {
    t3 = classNames(styles["modal-trigger__actions"], {
      [styles["modal-trigger__actions--is-theme-secondary"]]: isSecondaryTheme
    });
    $[4] = isSecondaryTheme;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== state) {
    t4 = () => state.setOpen(true);
    $[6] = state;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Menu />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== restTriggerProps || $[10] !== t4) {
    t6 = <Button {...restTriggerProps} aria-label="Menu" className={styles["modal-trigger__button"]} dataTestId="mobile-open-navigation-button" onClick={t4} variant={ButtonVariant.Plain}>{t5}</Button>;
    $[9] = restTriggerProps;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className={t3}>{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== overlayProps || $[17] !== state) {
    t8 = state.isOpen && <Drawer state={state}>{children && cloneElement(children(state.close), {
        ...overlayProps
      })}</Drawer>;
    $[15] = children;
    $[16] = overlayProps;
    $[17] = state;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className={styles["modal-trigger"]}>{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};